/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCurrentUserPylonPendingMessage200ResponseData
 */
export interface GetCurrentUserPylonPendingMessage200ResponseData {
    /**
     * Pylon message id awaiting a popup, or null when there is nothing pending
     */
    message_id: string;
}

/**
 * Check if a given object implements the GetCurrentUserPylonPendingMessage200ResponseData interface.
 */
export function instanceOfGetCurrentUserPylonPendingMessage200ResponseData(value: object): value is GetCurrentUserPylonPendingMessage200ResponseData {
    if (!('message_id' in value) || value['message_id'] === undefined) return false;
    return true;
}

export function GetCurrentUserPylonPendingMessage200ResponseDataFromJSON(json: any): GetCurrentUserPylonPendingMessage200ResponseData {
    return GetCurrentUserPylonPendingMessage200ResponseDataFromJSONTyped(json, false);
}

export function GetCurrentUserPylonPendingMessage200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentUserPylonPendingMessage200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'message_id': json['message_id'],
    };
}

export function GetCurrentUserPylonPendingMessage200ResponseDataToJSON(json: any): GetCurrentUserPylonPendingMessage200ResponseData {
    return GetCurrentUserPylonPendingMessage200ResponseDataToJSONTyped(json, false);
}

export function GetCurrentUserPylonPendingMessage200ResponseDataToJSONTyped(value?: GetCurrentUserPylonPendingMessage200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_id': value['message_id'],
    };
}

